'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _iBem = require('../../i-bem/i-bem.react');

exports.default = (0, _iBem.declMod)({ type: 'check' }, {
    block: 'select2',
    _onMenuClick: function _onMenuClick(e, val) {
        // Если это было событие с клавиатуры,
        // нужно предотвратить закрытие.
        e.keyCode && (this._preventToToggleOpenedForce = true);

        var next = this.state.val;
        var pos = next.indexOf(val);
        if (pos !== -1) {
            next.splice(pos, 1);
        } else {
            next.push(val);
        }
        this.setState({
            val: next
        });
        this._onChange(next);
    }
});